module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("John Reid is chair of the Trimontium Trust in Melrose and has published and lectured widely on the Roman Iron Age. For two decades he has led the Trust’s research projects, most notably at Burnswark Hill. Recent work has culminated in the complete renovation of Scotland’s only museum dedicated to the period of the Roman invasion. Originally intending to study classics, he trained as a doctor specialising in diseases of the heart and lungs, but has now returned to his first love of Scotland’s early history.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("‘"), _c('em', [_vm._v("The Eagle and the Bear")]), _vm._v(" is a fascinating account of the complex, and often violent, interactions between indigenous communities and Roman power in northern Britain. It is engagingly written and well-informed – a must read for anyone with an interest in Scotland’s past.’")]), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("Manuel Fernández-Götz, Abercromby Professor of Archaeology, University of Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("‘Probably the most complete history of Roman Scotland I’ve had the privilege to read. At once, scholarly, compellingly written and thought provoking, it brings a fresh perspective to the available evidence and provides genuine new insight into the study of the subject matter, with a forensic eye for detail. Most certainly a welcome addition to the genre.’")]), _vm._v(" "), _c('p', {
    staticClass: "parac"
  }, [_vm._v("Douglas Jackson, author and creator of the Gaius Valerius Verrens series")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f00ii-01.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Winter has come. Housesteads Roman fort on Hadrian’s Wall, looking west.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0